<template>
  <div class="container">
    <h2 class="header"><i class="fas fa-user-tag"></i> Detalles del usuario</h2>
    <table v-if="user" class="table">
      <tbody>
        <tr>
          <th>Id</th>
          <td>{{ user.id }}</td>
        </tr>
        <tr>
          <th>Nombre</th>
          <td>{{ user.name }}</td>
        </tr>
        <tr>
          <th>Email</th>
          <td>{{ user.email }}</td>
        </tr>
        <tr>
          <th>Creado</th>
          <td>{{ user.created_at }}</td>
        </tr>
        <tr>
          <th>Modificado</th>
          <td>{{ user.updated_at }}</td>
        </tr>
        <tr>
          <th>Acciones</th>
          <td>
            <div class="btn-group" role="group" aria-label="Basic example">
              <router-link class="btn btn-success" :to="{ name: 'Dashboard' }">
                <i class="fas fa-hand-point-left"></i> Regresar
              </router-link>
              <router-link
                class="btn btn-warning"
                v-if="user"
                :to="{ name: 'UsersEditar', params: { id: user.id } }"
              >
                <i class="fas fa-pencil-alt"></i> Editar
              </router-link>
              <button type="button" class="btn btn-danger">
                <i class="fas fa-trash-alt"></i> Borrar
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <pre>{{ user }}</pre>
  </div>
</template>

<script>
import User from "../../apis/User";

export default {
  data() {
    return {
      user: null
    };
  },
  created() {
    User.ver(this.$route.params.id).then(r => {
      this.user = r.data;
    });
  }
};
</script>
